import {formDataRequest, postRequest,getRequest} from '../libs/AxiosService.util';

export async function serviceCreateSpecialDeals(params) {
    return await formDataRequest('special/deals/create', params);
}
export async function serviceUpdateSpecialDeals(params) {
    return await formDataRequest('special/deals/update', params);
}

export async function serviceGetSpecialDeals(params) {
    return await postRequest('special/deals', params);
}

export async function serviceDeleteSpecialDeals(params) {
    return await formDataRequest('special/deals/delete', params);
}

export async function serviceGetKeywordsList(params) {
    return await postRequest('keywords', params);
}

export async function serviceChangeSpecialDealUser(params) {
    return await postRequest('/customers/toggle/admin/user', params);
}

export async function serviceGetUserSpecialDealsInterest(params) {
    return await postRequest('special/deal/interest', params);
}
